module.exports = __webpack_public_path__ + "img/login.273449b6.png";